import {
  PartnerApiStatus,
  PartnerStatus,
} from "~/entity/Partners/model/schema";

export const mapPartnerStatusFromApi = (
  status: PartnerApiStatus,
): PartnerStatus => (status === "ARCHIVED" ? "Архивный" : "Активный");

export const mapPartnerStatusToApi = (
  status: PartnerStatus,
): PartnerApiStatus => (status === "Архивный" ? "ARCHIVED" : "ACTIVE");
